import React from 'react';
import filterDetails from './filter-boxes';
import * as api from '../../../../services/api';
import RenewalsPortalPageHeader from '../../../presenters/renewals/RenewalsPortalPageHeader/RenewalsPortalPageHeader';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../RenewalsPortal/actions';
import {
  getQueryStringParam,
  serializeAsQueryString
} from '../../../../utils/utils';
import {
  getBranchIds,
  getBranchRouteNumbers
} from '../../../../utils/api-util';
import {
  DEFAULT_SELECTED_BRANCH_ROUTE_NUMBER,
  DEFAULT_SELECTED_DAY,
  DEFAULT_ACTIVE_BRANCH_ID
} from '../../../../constants/constants';
import { injectIntl } from 'react-intl';

const getBranchRouteNumberParam = () =>
  getQueryStringParam('branchRouteNumber') || null;

const getDayParam = () => Number(getQueryStringParam('day')) || null;

class RenewalsPortalPageHeaderWrapper extends React.Component {
  constructor(props) {
    super(props);

    const { activeBranchId, branches, routes } = this.props.appStore;
    const branchIds = getBranchIds(activeBranchId, branches);

    this.state = {
      filterCounts: filterDetails(props).map(() => 0),
      routes: routes
        .filter((route) => branchIds.includes(route.branchId))
        .map((route) => ({
          ...route,
          branchDesc: branches.find(
            (branch) => branch.branchId === route.branchId
          ).branchDesc
        }))
    };

    this.childRef = React.createRef();
    this._isMounted = false;
    this.fetchCounts = this.fetchCounts.bind(this);
    this.updateQueryState = this.updateQueryState.bind(this);
    this.getMappedFilterDetails = this.getMappedFilterDetails.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onChangeRoute = this.onChangeRoute.bind(this);
    this.onChangeDay = this.onChangeDay.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateState();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.appStore.activeBranchId !==
      prevProps.appStore.activeBranchId ||
      this.props.location !== prevProps.location
    ) {
      this.updateState();
    }
  }

  updateState() {
    this.props.actions.startLoading();

    this.fetchCounts()
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            filterCounts: response.map((r) => r.data)
          });
        }
      })
      .catch((err) => {
        console.error('something terrible happened: ', err);
      })
      .then(() => {
        this.props.actions.stopLoading();
      });
  }

  fetchCounts() {
    const { activeBranchId, branches } = this.props.appStore;
    const branchIds = getBranchIds(activeBranchId, branches);
    const branchRouteNumbers = getBranchRouteNumbers(
      getBranchRouteNumberParam(),
      this.state.routes.filter((route) => branchIds.includes(route.branchId))
    );

    return Promise.all(
      filterDetails(this.props).map((detail) => {
        const params = {
          contractExpiresAfter: detail.expiresAfter,
          contractExpiresBefore: detail.expiresBefore,
          hasTriggerProducts: detail.hasTriggerProducts,
          branchIds,
          branchRouteNumbers,
          dayId: getDayParam()
        };


        Object.keys(params).forEach((key) => {
          if (params[key] === undefined) delete params[key];
        });

        return branchIds.length > 0 && branchRouteNumbers.length > 0
          ? api.customers.count(params)
          : Promise.resolve({ data: 0 });
      })
    );
  }

  updateQueryState(queryString) {
    this.props.history.push(`/renewals?${queryString}`);
  }

  onSearch(searchTerm) {
    const hasSearchTerm = !!searchTerm && searchTerm.trim() !== '';
    const queryString = serializeAsQueryString(
      {
        search: hasSearchTerm ? searchTerm : null,
        title: hasSearchTerm ? `Search: ${searchTerm}` : null
      },
      true
    );
    this.updateQueryState(queryString);
  }

  onClick(filterDetail) {
    const queryString = serializeAsQueryString(
      {
        contractExpiresAfter: filterDetail.expiresAfter,
        contractExpiresBefore: filterDetail.expiresBefore,
        hasTriggerProducts: filterDetail.hasTriggerProducts,
        day: getDayParam(),
        branchRouteNumber: getBranchRouteNumberParam(),
        title: filterDetail.title
      },
      true
    );

    this.updateQueryState(queryString);

    this.childRef.current.onClearSearch();
  }

  getMappedFilterDetails() {
    return filterDetails(this.props).map((detail, index) => ({
      ...detail,
      count: this.state.filterCounts[index],
      onClick: () => this.onClick(detail)
    }));
  }

  getRoutes() {
    return [
      {
        branchRouteNumber: DEFAULT_SELECTED_BRANCH_ROUTE_NUMBER,
        display: this.props.intl.formatMessage({ id: 'all_routes' })
      },
      ...this.state.routes
        .sort((a, b) => a.branchId - b.branchId)
        .sort((a, b) => a.routeNumber - b.routeNumber)
        .map((route) => ({
          branchRouteNumber: `${route.branchId}:${route.routeNumber}`,
          display:
            this.props.appStore.activeBranchId === DEFAULT_ACTIVE_BRANCH_ID
              ? `${route.branchDesc} ${this.props.intl.formatMessage({
                id: 'route'
              })}# ${route.routeNumber}`
              : `${route.routeNumber}`
        }))
    ];
  }

  onChangeRoute(selectedBranchRouteNumber) {
    const branchRouteNumber =
      selectedBranchRouteNumber !== DEFAULT_SELECTED_BRANCH_ROUTE_NUMBER
        ? selectedBranchRouteNumber
        : null;
    const queryString = serializeAsQueryString(
      {
        day: getDayParam(),
        branchRouteNumber
      },
      true
    );
    this.updateQueryState(queryString);

    this.childRef.current.onClearSearch();
  }

  onChangeDay(selectedDay) {
    const day = selectedDay !== DEFAULT_SELECTED_DAY ? selectedDay : null;
    const queryString = serializeAsQueryString(
      {
        branchRouteNumber: getBranchRouteNumberParam(),
        day
      },
      true
    );
    this.updateQueryState(queryString);

    this.childRef.current.onClearSearch();
  }

  render() {
    return (
      <RenewalsPortalPageHeader
        ref={this.childRef}
        onSearch={this.onSearch}
        filterDetails={this.getMappedFilterDetails()}
        selectedBranchRouteNumber={
          getBranchRouteNumberParam() || DEFAULT_SELECTED_BRANCH_ROUTE_NUMBER
        }
        routes={this.getRoutes()}
        onChangeRoute={this.onChangeRoute}
        selectedDay={getDayParam() || DEFAULT_SELECTED_DAY}
        onChangeDay={this.onChangeDay}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(RenewalsPortalPageHeaderWrapper)
  )
);